import styled from 'styled-components';

import { getTypography } from '../../../../../shared/utils/style-utils';

export const Value = styled.span`
  ${({ theme }) => getTypography(theme.typography.body.big)};
  font-weight: 700;
`;
